import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors, type ThemeColorValues } from '@tokens/colors.stylex';

// Light counterpart. Ported from the locked prototype
// (.ai/domains/frontend/design/prototype/assets/styles.css → [data-theme="light"]).
export const lightTheme = {
  x1sj0b7k: "xf1nupl x1sj0b7k",
  $$css: true
};